import { CmsApiGradCtaHeroBlockData } from 'modules/cms/api/types/CmsApiGradCtaHero';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpGradCtaHeroBlock } from './CmsAmpGradCtaHeroBlock';
import { CmsGradCtaHeroBlock } from './CmsGradCtaHeroBlock';

export const CmsGradCtaHeroBlockMapping: CmsBlockMapping<CmsApiGradCtaHeroBlockData> =
  {
    invariant: [
      {
        prop: 'text',
        msg: 'Text data required for call to action',
      },
      {
        prop: 'image',
        msg: 'Image data required for call to action',
      },
    ],
    width: CmsBlockWidth.FULL,
    Component: CmsGradCtaHeroBlock,
    AmpComponent: CmsAmpGradCtaHeroBlock,
  };
